module.exports = __webpack_public_path__ + "img/favorite-active.dd1826ee.svg";